import axios from "axios";
import { PROVIDERNODE_BASE_URL } from "../../DoctorMangement/constant";
import { jsonParser } from '../../../helper/jsonParser'
import { ToastEmitter } from "../../DoctorMangement/ToastEmitter";
import { unauthorizedErrorToastEmitter } from "../../../helper/utils";
const hostname = PROVIDERNODE_BASE_URL;


export const getSPOCDetails = async (data) => {
  try {
    let config = {
      method: "post",
      url: hostname + "/provider/getSpocList",
      headers: {
        'Content-Type': "application/json",
        accesstoken: jsonParser(localStorage.getItem("access_token")),
      },
      data: data
    }
    let response = await axios(config);

    return response.data;


  } catch (err) {
    console.log(err);
    unauthorizedErrorToastEmitter(err)
    throw (err.message);
  }
}

export const UpdateSPOC = async (data) => {
  try {
    const config = {
      method: 'POST',
      url: hostname + "/provider/updateSpocProfile",
      headers: {
        'Content-Type': "application/json",
        accesstoken: jsonParser(localStorage.getItem("access_token")),
      },
      data: data
    }
    let response = await axios(config);

    return response.data;
  }
  catch (err) {
    return err
  }
}


export const CreateSPOC = async (data) => {
  try {
    const config = {
      method: 'POST',
      url: hostname + "/provider/CreateUser",
      headers: {
        'Content-Type': "application/json",
        accesstoken: jsonParser(localStorage.getItem("access_token")),
      },
      data: data
    }
    let response = await axios(config);
    return response.data;
  }
  catch (err) {
    return err
  }
}


export const getUserDetails = async (data)=>{
  try {
    const config = {
      method: 'GET',
      url: hostname + "/provider/getSPOCDetails",
      headers: {
        'Content-Type': "application/json",
        accesstoken: jsonParser(localStorage.getItem("access_token")),
      },
      params: {
        userName: data.userName,
        userId: data.userId,
      },
    }
    let response = await axios(config);
    return response.data;
  }
  catch (err) {
    return null
  }
}

export const resetPassowrdForUser = async (userName, entityId)=>{
    try {
        const config = {
          method: 'POST',
          url: hostname + "/provider/resetPassword",
          headers: {
            'Content-Type': "application/json",
            accesstoken: jsonParser(localStorage.getItem("access_token")),
          },
          data: {
            username: userName,
            entityId: entityId
          },
        }
        let response = await axios(config);
        return response.data;
      }
      catch (err) {
        unauthorizedErrorToastEmitter(err)
        throw err;
      }
}

export const getRoles = async () => {
  try {
    const config = {
      method: 'GET',
      url: hostname + "/provider/getRoles",
      headers: {
        'Content-Type': "application/json",
        accesstoken: jsonParser(localStorage.getItem("access_token")),
      },
      params: {
        appId: 10007,
      }
    }
    const resp = await axios(config);
    if(resp.status == 200){
      return resp.data;
    }
    return null
  }
  catch (err) {
    console.log(err);
    return null
  }
  }

  export const UpdateSPOCStatus = async (data) => {
    try {
      const config = {
        method: 'POST',
        url: hostname + "/provider/updateSpocStatus",
        headers: {
          'Content-Type': "application/json",
          accesstoken: jsonParser(localStorage.getItem("access_token")),
        },
        data: data
      }
      let response = await axios(config);
      return response.data;
    }
    catch (err) {
        ToastEmitter('You do not have permission to perform this action', 'error')
        return null
    }
  }

  export const generateResetPasswordLink = async (userName)=>{
    try {
      const config = {
        method: 'POST',
        url: hostname + "/provider/forgotPassword",
        headers: {
          'Content-Type': "application/json",
          accesstoken: jsonParser(localStorage.getItem("access_token")),
        },
        data: {
          username: userName,
        },
      }
      let response = await axios(config);
      return response.data;
    }
    catch (err) {
      unauthorizedErrorToastEmitter(err)
      throw err;
    }
  }